import { TOKEN_EXPIRED } from '../types';

export const setTokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export default () => async (dispatch) => {
    dispatch(setTokenExpired());
};
